import { render } from "./SearchByTopicComponent.vue?vue&type=template&id=473532ce&scoped=true"
import script from "./SearchByTopicComponent.vue?vue&type=script&lang=js"
export * from "./SearchByTopicComponent.vue?vue&type=script&lang=js"

import "./SearchByTopicComponent.vue?vue&type=style&index=0&id=473532ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-473532ce"]])

export default __exports__